var $2b6e161c9edcf319$exports = {};
const $2b6e161c9edcf319$var$nav = document.querySelector(".mobile-nav--js");
const $2b6e161c9edcf319$var$barBtn = document.querySelector(".bar-btn--js");
const $2b6e161c9edcf319$var$closeBtn = document.querySelector(".close-btn--js");
$2b6e161c9edcf319$var$barBtn.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$nav.classList.remove("hidden");
    $2b6e161c9edcf319$var$closeBtn.classList.remove("hidden");
    $2b6e161c9edcf319$var$barBtn.classList.add("hidden");
});
$2b6e161c9edcf319$var$closeBtn.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$nav.classList.add("hidden");
    $2b6e161c9edcf319$var$barBtn.classList.remove("hidden");
    $2b6e161c9edcf319$var$closeBtn.classList.add("hidden");
});


//# sourceMappingURL=index.33f00541.js.map
